import PkList from './pk-list';

const Pk = (props) => {
  const { data } = props;
  if (data.pk_list && data.pk_list.length > 0) {
    return (
      <section className="common-sec pk-sec">
        <div className="sec-header">
          <i className="icon-index icon-index-pk"></i>
          <div className="sec-label">激情PK</div>
        </div>
        <div className="pk-list clearfix">
          <PkList
            data={{
              list: data.pk_list,
              isAuto: true,
              saId: '001t03l02+000',
            }}
            clickfrom="J138"
          ></PkList>
        </div>
      </section>
    );
  }
  return null;
};

export default Pk;
